// Public scheduled invitations and existing random document aliases.
export const shortDocumentPattern=/^\/((?=[A-Za-z0-9]{0,5}[0-9])[A-Za-z0-9]{6}|live-(?:session|purge)-[1-9][0-9]{0,9})$/;
